import * as CompanyService from "../../services/templateServices/CompanyService"
export const useCompany = () => {

    const CompanyItem = async( IdCompany ) => {
        const response = await CompanyService.GetCompanyItem( IdCompany );
        return response;
    }

    return {
        CompanyItem,
    }
}